import React from "react";
import { FaBars } from "react-icons/fa";
import { useGlobalContext } from "./context";
import "./home.css";

const Home = () => {
  const { openSidebar, openModal } = useGlobalContext();
  return (
    <main className="sidebarhome">
      <button onClick={openSidebar} className="sidebar-toggle">
        <FaBars />
      </button>
      <button onClick={openModal} className="btn">
        show modal
      </button>
    </main>
  );
};

export default Home;
